module.exports = __webpack_public_path__ + "static/media/register-login-bg.dd6c1cff.jpg";